export const MAX_WIDTH_MOBILE = 520;
